export default __webpack_public_path__ + "static/media/Digital_Delay_Generators.8d74e1f6.png";